export default __webpack_public_path__ + "media/images/bg-police-e4346e1e646a410c704b03cabff2f295.jpg";